var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.175 13.225L7.975 9.025C7.6 9.325 7.16875 9.5625 6.68125 9.7375C6.19375 9.9125 5.675 10 5.125 10C3.7625 10 2.60937 9.52813 1.66562 8.58438C0.721875 7.64063 0.25 6.4875 0.25 5.125C0.25 3.7625 0.721875 2.60938 1.66562 1.66563C2.60937 0.721875 3.7625 0.25 5.125 0.25C6.4875 0.25 7.64062 0.721875 8.58437 1.66563C9.52812 2.60938 10 3.7625 10 5.125C10 5.675 9.9125 6.19375 9.7375 6.68125C9.5625 7.16875 9.325 7.6 9.025 7.975L13.2437 12.1938C13.3812 12.3313 13.45 12.5 13.45 12.7C13.45 12.9 13.375 13.075 13.225 13.225C13.0875 13.3625 12.9125 13.4313 12.7 13.4313C12.4875 13.4313 12.3125 13.3625 12.175 13.225ZM5.125 8.5C6.0625 8.5 6.85937 8.17188 7.51562 7.51563C8.17187 6.85938 8.5 6.0625 8.5 5.125C8.5 4.1875 8.17187 3.39063 7.51562 2.73438C6.85937 2.07813 6.0625 1.75 5.125 1.75C4.1875 1.75 3.39062 2.07813 2.73437 2.73438C2.07812 3.39063 1.75 4.1875 1.75 5.125C1.75 6.0625 2.07812 6.85938 2.73437 7.51563C3.39062 8.17188 4.1875 8.5 5.125 8.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.c8a0d642ccb90be64048976644ae5014.svg";
export { ForwardRef as ReactComponent };